import { isExpanded, collapse } from '~/js/utils/expand-collapse';
import { default as mobileCheck } from '~/js/utils/is-mobile';

// toggle class when page is scrolled
const { body } = document;
const header = document.getElementById('header');
const arDropdown = document.querySelector('.ar-download');
const dropdownToggle = document.querySelector('.ar-download__toggle');
const dropdownList = document.querySelector('.ar-download__list');
const dropdownHiddenClass = 'ar-download--hidden';
let lastScrollPosition = 0;

const setScrollingClass = () => {
  const windowScrollY = window.scrollY;
  const isMobile = mobileCheck('m');
  // prevent toggling the 'scroll' event when we open navigation.
  if (lastScrollPosition && windowScrollY === 0) {
    return;
  }

  // exit if on maintenance page for example
  if (!header) {
    return;
  }

  const isScrolling = windowScrollY > header.offsetTop + 100;
  // add general scrolling class to the body
  body.classList.toggle('scrolling', isScrolling);

  // If the AR download dropdown is open, close it when scrolling down.
  if (isExpanded(dropdownList)) {
    collapse(dropdownList, dropdownToggle);
  }

  // check for scroll direction
  if (windowScrollY > lastScrollPosition) {
    // when scrolling down
    if (body.classList.contains('scrolling--top') && lastScrollPosition !== 0) {
      body.classList.remove('scrolling--top');
    }

    // On mobile, hide the AR dropdown when scrolling down.
    if (isMobile) {
      arDropdown?.classList.add(dropdownHiddenClass);
    }
  } else if (lastScrollPosition - windowScrollY > 30 && windowScrollY !== 0) {
    // when scrolling up
    body.classList.add('scrolling--top');

    // On mobile, show the AR dropdown when scrolling up.
    if (isMobile) {
      arDropdown?.classList.remove(dropdownHiddenClass);
    }
  }

  // update latest scroll position
  lastScrollPosition = Math.max(0, windowScrollY);
};

const resetHiddenClass = () => {
  const isMobile = mobileCheck('m');

  if (!isMobile) {
    arDropdown?.classList.remove(dropdownHiddenClass);
  }
};

// event listeners
window.addEventListener('scroll', setScrollingClass);

window.addEventListener('resize', resetHiddenClass);

document.addEventListener('DOMContentLoaded', () => setScrollingClass());
